import {
  EntityAccentuateInfo,
  isAccentuateEnabled,
} from '@internal/backstage-plugin-accentuate';
import React from 'react';

import { FeatureFlagged } from '@backstage/core-app-api';
import { EntityLinksCard, EntitySwitch } from '@backstage/plugin-catalog';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';

import { Grid } from '@material-ui/core';

import { isLinksNotEmpty } from '../entityUtils';
import { ActionContent } from './ActionContent';
import { EntityWarningContent } from './EntityWarningContent';
import { ServiceAboutCard } from './ServiceAboutCard';

export const ServiceEntityOverviewContent = (
  <Grid container spacing={3} alignItems="stretch">
    <EntityWarningContent />
    <FeatureFlagged with="show-accentuate-sidebar">
      <EntitySwitch>
        <EntitySwitch.Case if={isAccentuateEnabled}>
          <Grid item xs={12}>
            <EntityAccentuateInfo />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>
    </FeatureFlagged>
    {ActionContent}
    <EntitySwitch>
      <EntitySwitch.Case>
        <Grid item md={6}>
          <ServiceAboutCard variant="gridItem" />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>

    <EntitySwitch>
      <EntitySwitch.Case>
        <Grid item md={6} xs={12}>
          <EntityCatalogGraphCard variant="gridItem" height={400} />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>

    <EntitySwitch>
      <EntitySwitch.Case if={isLinksNotEmpty}>
        <Grid item md={6} xs={12}>
          <EntityLinksCard />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>
  </Grid>
);
